import styled from '@emotion/styled'

export const BillAddLineButtonWrapper = styled.div``
